<template>
  <v-container>
    <h1>Match Tester</h1>
    <hr />

    <v-card>
      <v-card-title />
      <v-card-text>
        <v-tabs
          :value="activeTab"
          @change="activeTab = $event">
          <v-tab :key="0">Questions</v-tab>
          <v-tab :key="1">Results</v-tab>

          <v-tab-item :key="0">
            <QuestionsForm
              :loading="loading"
              @submit="submit" />
          </v-tab-item>

          <v-tab-item :key="1">
            <Results
              v-if="results"
              :results="results" />
          </v-tab-item>
        </v-tabs>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'

import QuestionsForm from './QuestionsForm'
import Results from './Results'

export default {
  name: 'MatchTester',
  components: {
    QuestionsForm,
    Results,
  },

  data: () => ({
    results: null,
    activeTab: 0,
  }),

  computed: {
    ...mapGetters('feathers', ['apiDeals']),
  },

  methods: {
    async submit (formData) {
      this.loading = true

      this.results = await this.apiDeals.create(formData, {
        query: {
          $client: {
            testMode: true,
          },
        },
      })

      this.activeTab = 1
      this.loading = false
    },
  },
}
</script>

<style lang="scss" scoped>
.v-card__title {
  background-color: $accentBlue;
}

::v-deep {
  .v-tabs-bar__content {
    justify-content: flex-start !important;
  }
}
</style>
